import React from 'react';
import { GenericCloseButton, GenericModal } from '../..';

import {
    ModalCard,
    ActionRow,
} from './style'

export const  BaseModal = ({ 
    content,
    actionChildren,
    onClose,
    ...rest 
}) => {
    return (
        <GenericModal opacity={0.5}>
            <ModalCard {...rest}>
                {content}
                <ActionRow>
                    {actionChildren}
                </ActionRow>
                <GenericCloseButton
                    style={{
                        position: 'absolute',
                        top: '15px',
                        right: '17px',
                    }}
                    onClick={onClose} />
            </ModalCard>
        </GenericModal>
    )
}

BaseModal.defaultProps = {
    btnProps: {},
    onClose: () => {}
}



